import { SwitchTextTypeCommand, annotationHelpers } from "substance"
import { idGenerator } from '../../../../../lib/utils/IdGenerator'

/**
 * DWSwitchTextTypeCommand allows user to change text type on one or multiple
 * text blocks.
 *
 * TODO: Everything in Substance SwitchTextTypeCommand should be moved to this class.
 * TODO: Command should be moved into the Writer!
 * TOOD: This class should extend Command.
 */
class DWSwitchTextTypeCommand extends SwitchTextTypeCommand {
    execute(params) {
        const surface = params.surface
        if (!surface) {
            console.warn('No focused surface. Stopping command execution.')
            return
        }

        const editorSession = params.editorSession
        const nodes = this.getSelectedTextNodes(editorSession)
        if (!nodes.length) {
            return
        }

        const textType = this.getTextType(params)
        const _this = this
        const startOffset = params.selection.start.offset
        const endOffset = params.selection.end.offset
        editorSession.transaction(function (tx) {
            const newNodes = nodes.map(node => {
                return _this.switchTextType(tx, surface.containerId, textType, node)
            })

            tx.setSelection({
                type: 'container',
                containerId: surface.containerId,
                startOffset: startOffset,
                endOffset: endOffset,
                startPath: [newNodes[0].id, 'content'],
                endPath: [newNodes[newNodes.length - 1].id, 'content']
            })
        })
    }


    /**
     * Find and return all nodes affected by switching text type
     *
     * @param {object} EditorSession
     * @return {array}
     */
    getSelectedTextNodes(editorSession) {
        const sel = editorSession.getSelection()

        if (!sel.containerId) {
            throw new Error("Selection must be within a container.")
        }

        const doc = editorSession.getDocument()
        const containerNode = doc.get(sel.containerId)
        const nodes = []

        if (sel.isPropertySelection()) {
            nodes.push(doc.get(sel.start.path[0]))
        }
        else if (sel.isContainerSelection()) {
            let inSelection = false

            containerNode.nodes.forEach(nodeId => {
                if (nodeId === sel.start.path[0]) {
                    inSelection = true
                }

                if (inSelection) {
                    const node = doc.get(nodeId)
                    if (node.isInstanceOf('text')) {
                        nodes.push(node)
                    }
                }

                if (nodeId === sel.end.path[0]) {
                    inSelection = false
                }
            })
        }

        return nodes
    }

    /**
     * Change the text type on a node
     *
     * @param {TransactionDocument} tx
     * @param {object}              textType
     * @param {string}              containerId
     * @param {array}               node
     */
    switchTextType(tx, containerId, textType, node) {
        if (!node.isInstanceOf('text')) {
            throw new Error('Trying to use switchTextType on a non text node. Skipping.')
        }

        // create a new node and transfer annotations
        const data = textType.data
        let newNode = Object.assign({
            id: idGenerator(data.type),
            type: data.type,
            content: node.content,
            direction: node.direction
        }, data)

        const oldPath = [node.id, 'content']
        const newPath = [newNode.id, 'content']
        newNode = tx.create(newNode)
        annotationHelpers.transferAnnotations(tx, oldPath, 0, newPath, 0)

        // hide the old one, show the new node
        let container = tx.get(containerId)
        let pos = container.getPosition(node.id, 'strict')
        container.hide(node.id)
        container.show(newNode.id, pos)

        // remove the old one from the document
        tx.delete(node.id)

        return newNode
    }
}

export { DWSwitchTextTypeCommand }
